import { FC, ReactElement, useMemo } from 'react';

import { CampaignArchiveReason, CampaignPauseReason, CampaignStatus } from 'utils/constants/dashboard';

import Active from 'components/CampaignCard/CampaignInfo/Actions/Status/Active';
import ActiveWithDelayedStart from 'components/CampaignCard/CampaignInfo/Actions/Status/ActiveWithDelayedStart/ActiveWithDelayedStart';
import Archived from 'components/CampaignCard/CampaignInfo/Actions/Status/Archived';
import Blocked from 'components/CampaignCard/CampaignInfo/Actions/Status/Blocked';
import InactiveDueToEndDate from 'components/CampaignCard/CampaignInfo/Actions/Status/InactiveDueToEndDate/InactiveDueToEndDate';
import StatusPaused from 'components/CampaignCard/StatusPaused';

import { Banner, FrontendStatusType } from 'store/models/dashboard';

import 'components/CampaignCard/CampaignInfo/Actions/Status/Status.less';

interface StatusProps {
    frontendStatus: FrontendStatusType;
    archiveReason: CampaignArchiveReason | null;
    banners: Banner[];
    campaignId: number;
    userBalance: number;
    realBalance: number;
    isAuction: boolean;
    vacancyId: number | null;
    startAt: string | null;
    endAt: string | null;
}

const Status: FC<StatusProps> = ({
    campaignId,
    frontendStatus,
    userBalance,
    realBalance,
    archiveReason,
    banners,
    isAuction,
    vacancyId,
    startAt,
    endAt,
}) => {
    const statusContent: ReactElement | null = useMemo(() => {
        if (frontendStatus === CampaignStatus.Active) {
            return <Active />;
        }
        if (frontendStatus === CampaignStatus.ActiveWithDelayedStart) {
            return <ActiveWithDelayedStart startAt={startAt} />;
        }
        if (frontendStatus === CampaignStatus.Blocked) {
            return <Blocked />;
        }
        if (frontendStatus === CampaignStatus.Archived) {
            return (
                <Archived
                    banners={banners}
                    campaignId={campaignId}
                    archiveReason={archiveReason}
                    isAuction={isAuction}
                />
            );
        }
        if (frontendStatus === CampaignStatus.InactiveDueToEndDate) {
            return <InactiveDueToEndDate endAt={endAt} />;
        }
        if (
            frontendStatus === CampaignPauseReason.DailyBudgetExceedStatus ||
            frontendStatus === CampaignPauseReason.BudgetExceeded
        ) {
            return (
                <StatusPaused
                    campaignId={campaignId}
                    frontendStatus={frontendStatus}
                    userBalance={userBalance}
                    realBalance={realBalance}
                    isBanner={false}
                    isAuction={isAuction}
                    vacancyId={vacancyId}
                />
            );
        }
        return null;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [frontendStatus]);

    return (
        <div className="clickme-status" data-qa="campaign-status">
            {statusContent}
        </div>
    );
};

export default Status;
